module.exports = __webpack_public_path__ + "media/gifts/gift-botox-10-36aae7ab.png";